import React, { Component } from 'react';
import { connect } from 'react-redux';
import HTTPStatus from 'http-status';
import PropTypes from 'prop-types';
import { Modal, Input, Button, Form, Spin } from 'antd';

import { crearMissatgeError } from '../../../commons/missatgeServidor';
import { selectorLogin } from '../../../selectors/selector_login';
import { fetchModificarContrasenya } from '../../../commons/consultesServidor';
import { crearNotificacioSuccess } from '../../../commons/notificacio';
import { guardarToken } from '../../../commons/gestioWebToken';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../../constants';

const FormItem = Form.Item;

const campContrasenyaActual = 'contrasenyaActual';
const campNovaContrasenya = 'novaContrasenya';
const campNovaContrasenya2 = 'novaContrasenya2';

class ModificarContrasenya extends Component {
    constructor(props) {
        super(props);

        this.state = { modalVisible: false, consultaModificarContrasenyaEnCurs: false };
        this.onClickOk = this.onClickOk.bind(this);
        this.mostrarModal = this.mostrarModal.bind(this);
        this.amagarModal = this.amagarModal.bind(this);
    }

    onClickOk(event) {
        const idUsuari = this.props.idUsuari;
        const { validateFields, setFields, getFieldValue } = this.props.form;

        event.preventDefault();

        //Validació formulari
        validateFields({force: true}, (error, values) => {
            if (!error) {
                this.setState({...this.state, consultaModificarContrasenyaEnCurs: true });

                const { contrasenyaActual, novaContrasenya } = values;
                fetchModificarContrasenya(idUsuari, contrasenyaActual, novaContrasenya)
                    .then(respostaServidor => {
                        this.setState({...this.state, consultaModificarContrasenyaEnCurs: false });

                        this.amagarModal();

                        //Canvi de token
                        const { token} = respostaServidor;
                        guardarToken(token);

                        crearNotificacioSuccess('La contrasenya s\'ha modificat correctament');
                    },
                    respostaServidor => {
                        this.setState({...this.state, consultaModificarContrasenyaEnCurs: false });

                        if (respostaServidor.status !== HTTPStatus.UNAUTHORIZED) {
                            crearMissatgeError();
                            return;
                        }

                        const missatgeError = 'La contrasenya introduïda no és correcta.';
                        setFields({
                            [campContrasenyaActual]:
                            {
                                value: getFieldValue(campContrasenyaActual),
                                errors: [new Error(missatgeError)]
                            }
                        });
                    });
            }
        });
    }

    mostrarModal() {
        this.setState({...this.state, modalVisible: true});
    }

    amagarModal() {
        const { resetFields } = this.props.form;
        this.setState({...this.state, modalVisible: false});
        resetFields();
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { modalVisible, consultaModificarContrasenyaEnCurs } = this.state;

        const validacioContrasenyes = (rule, value, callback) => {
            if (getFieldValue(campNovaContrasenya) === getFieldValue(campNovaContrasenya2)) {
                return callback();
            }
            callback(['Les contrasenyes han de coincidir.']);
        };
        const opcioCampObligatori = { required: true, message: 'Aquest camp és obligatori.' };
        const opcioContrasenyesHanDeCoincidir = { validator: validacioContrasenyes };
        const opcionsInputContrasenyaActual = {rules: [opcioCampObligatori]};
        const opcionsInputNovaContrasenya = {
            validateTrigger: null,
            rules: [opcioCampObligatori, opcioContrasenyesHanDeCoincidir]
        };

        const inputContrasenya = <Input type='password' />;

        return <div>
            <div onClick={this.mostrarModal}>Modificar contrasenya</div>
            <Modal
                visible={modalVisible}
                title='Modificar contrasenya'
                className='modificar-contrasenya'
                closable={false}
                footer={[
                    <Button key='ok' type='primary' disabled={consultaModificarContrasenyaEnCurs} onClick={this.onClickOk}>OK</Button>,
                    <Button key='cancel' disabled={consultaModificarContrasenyaEnCurs} onClick={this.amagarModal}>Cancel·lar</Button>
                ]}>
                <Spin spinning={consultaModificarContrasenyaEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                    <Form onSubmit={this.onClickOk}>
                        <FormItem>
                            <span>Contrasenya actual:</span>
                            {getFieldDecorator(campContrasenyaActual, opcionsInputContrasenyaActual)(inputContrasenya)}
                        </FormItem>
                        <FormItem>
                            <span>Nova contrasenya:</span>
                            {getFieldDecorator(campNovaContrasenya, opcionsInputNovaContrasenya)(inputContrasenya)}
                        </FormItem>
                        <FormItem>
                            <span>Repetir contrasenya:</span>
                            {getFieldDecorator(campNovaContrasenya2, opcionsInputNovaContrasenya)(inputContrasenya)}
                        </FormItem>
                    </Form>
                </Spin>
            </Modal>
        </div>;
    }
}


ModificarContrasenya.propTypes = {
    idUsuari: PropTypes.number,
    form: PropTypes.object, //Prop passada automàticament per la funció Form.create()
};

const mapStateToProps = (state) => ({
    idUsuari: selectorLogin(state).idUsuari
});

export default connect(mapStateToProps)(Form.create()(ModificarContrasenya));



// WEBPACK FOOTER //
// ./src/components/capcalera/menu/modificarContrasenya.js